<div class="transport-overview-filter no-field-space" [formGroup]="filterFormGroup">
  <sc-flex>
    <mat-form-field class="filter-field" appearance="fill">
      <input matInput [maxLength]="255" name="filterText" formControlName="filterText">
      <mat-label>{{'Filter' | translate: ['shared.tmc-table.filter', translationService.language]}}</mat-label>
    </mat-form-field>
    <sc-content-spacer></sc-content-spacer>
    <div class="scopeFilter" [ngClass]="{'selected': transportSelection?.scopeTrain}" (click)="switchScopeTrain()">
      <app-transport-scope-icon scope="TRAIN"
        [matTooltip]="'train' | translate: ['tmc-yard.common.enum.transport-scope.TRAIN', translationService.language]">
      </app-transport-scope-icon>
    </div>
    <sc-content-spacer></sc-content-spacer>
    <div class="scopeFilter" [ngClass]="{'selected': transportSelection?.scopeTrailer}" (click)="switchScopeTrailer()">
      <app-transport-scope-icon scope="TRAILER"
        [matTooltip]="'trailer' | translate: ['tmc-yard.common.enum.transport-scope.TRAILER', translationService.language]">
      </app-transport-scope-icon>
    </div>
    <sc-content-spacer></sc-content-spacer>
    <div class="scopeFilter" [ngClass]="{'selected': transportSelection?.scopeSwapTrailer}" (click)="switchScopeSwapTrailer()">
      <app-transport-scope-icon scope="SWAP_TRAILER"
        [matTooltip]="'swap trailer' | translate: ['tmc-yard.common.enum.transport-scope.SWAP_TRAILER', translationService.language]">
      </app-transport-scope-icon>
    </div>
    <sc-content-spacer></sc-content-spacer>
    <div class="scopeFilter" [ngClass]="{'selected': transportSelection?.scopeSemiTrailerTruck}" (click)="switchScopeSemiTruckTrailer()">
      <app-transport-scope-icon scope="SEMI_TRAILER_TRUCK"
        [matTooltip]="'semi trailer truck' | translate: ['tmc-yard.common.enum.transport-scope.SEMI_TRAILER_TRUCK', translationService.language]">
      </app-transport-scope-icon>
    </div>
    <sc-content-spacer></sc-content-spacer>
    <mat-form-field class="custom-filter-field" appearance="fill">
      <mat-label>
        {{'filter ' | translate: ['tmc.visit.overview.customFilter', translationService.language]}}
      </mat-label>
      <mat-select name="customFilter" formControlName="customFilter">
        <mat-option [value]="-1">
          {{ 'none' | translate: ['tmc.visit.overview.customFilter.option.none', translationService.language]}}
        </mat-option>
        <mat-option *ngFor="let filter of filters" [value]="filter.id">
          {{filter.id | translate: [filter.dictionaryKey, translationService.language]}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </sc-flex>
</div>